import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";

export async function createQuotationTemplateAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/create-template`,
    data.data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function updateQuotationTemplateAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/update-template`,
    data.data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function toggleQuotationTemplateAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API +
      `${
        data.sale_order ? "sale-orders" : "quotations"
      }/toggle-template-status/${data.template_id}`,
    { ...data, sale_order: undefined },
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function defaultQuotationTemplateAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/set-default-template/${
        data.template_id
      }`,
    { ...data, sale_order: undefined },
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function getListQuotationTemplateAPI(data) {
  const token = await checkTokenExpiration();
  return axios.get(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/get-list-templates`,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function deleteQuotationTemplateAPI(data) {
  const token = await checkTokenExpiration();
  return axios.delete(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/delete-templates`,
    {
      headers: {
        Authorization: token,
      },
      data: { ...data, sale_order: undefined },
    }
  );
}

export async function deleteQuotationAPI(data) {
  const token = await checkTokenExpiration();
  return axios.delete(BASE_URL_API + `quotations/${data.quotation_id}/delete`, {
    headers: {
      Authorization: token,
    },
  });
}

export async function getListQuotationItemAPI(data) {
  const token = await checkTokenExpiration();
  return axios.get(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/${
        data.quotation_id
      }/items`,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function createQuotationItemAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/${
        data.quotation_id
      }/items/create`,
    data.data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function updateQuotationItemAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/${
        data.quotation_id
      }/items/${data.quotation_item_id}/update`,
    data.data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function updatePositionQuotationItemAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/${
        data.quotation_id
      }/items/update-position`,
    data.data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function deleteQuotationItemAPI(payload) {
  const token = await checkTokenExpiration();
  return axios.delete(
    BASE_URL_API +
      `${payload.sale_order ? "sale-orders" : "quotations"}/${
        payload.quotation_id
      }/items/delete`,
    {
      headers: {
        Authorization: token,
      },
      data: payload.data,
    }
  );
}

export async function getQuotationHistoryAPI(data) {
  const token = await checkTokenExpiration();
  return axios.get(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/${
        data.quotation_id
      }/get-history`,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function renderTemplateAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API +
      `${data.sale_order ? "sale-orders" : "quotations"}/render-template`,
    data.data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}
